import React from 'react';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import Error from '../../authentication/Error';
import { useAppSelector } from '../../../store';
import { ENUM_STRING_MENU } from '../../../enums/enums';
import AggregatorContent from './AggregatorContent';

export default function SettingAggregator() {
  const hiddenMenuItems = useAppSelector((state) => state.info.hiddenMenuItems);

  const isPageHide = hiddenMenuItems.includes(ENUM_STRING_MENU.gambitAggregator);

  return (
    <ShowContainer condition={!isPageHide} plug={<Error height="calc(100svh - 100px)" />}>
      <CusPageCardContainer title={'Provider settings'}>
        <AggregatorContent />
      </CusPageCardContainer>
    </ShowContainer>
  );
}
